export function vehicleReportViewItem(vin, price, currencyCode, make, model) {
  vehicleReport("view_item", vin, price, currencyCode, make, model)
}

export function vehicleReportAddToCart(vin, price, currencyCode, make, model) {
  vehicleReport("add_to_cart", vin, price, currencyCode, make, model)
}

export function apiCreditsAddToCart(price, currencyCode, creditType, creditAmount) {
  apiCredits("add_to_cart", price, currencyCode, creditType, creditAmount);
}

function apiCredits(eventName, price, currencyCode, creditType, creditAmount) {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ecommerce: null});

  window.dataLayer.push({
    event: eventName,
    ecommerce: {
      currency: currencyCode,
      items: [{
        item_name: 'API Credits',
        item_id: `${creditAmount} ${creditType}`.toLowerCase().replace(/\W+/g, "_"),
        price: price,
        currency: currencyCode,
        item_brand: creditType,
        item_variant: creditAmount,
        item_category: 'API Credits',
        quantity: 1
      }]
    }
  });
}

function vehicleReport(eventName, vin, price, currencyCode, make, model) {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ecommerce: null});

  window.dataLayer.push({
    event: eventName,
    ecommerce: {
      currency: currencyCode,
      items: [{
        item_name: 'Vehicle Report',
        item_id: '1_vehicle_report',
        price: price,
        currency: currencyCode,
        item_brand: make,
        item_variant: model,
        item_category: 'Vehicle Report',
        quantity: 1
      }]
    }
  });
}
